import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import './utils/plugins/Leaflet-awesome-markers/font/bootstrap-icons.min.css';
import './utils/plugins/Leaflet-awesome-markers/leaflet.awesome-markers.css'
import './utils/plugins/Leaflet-awesome-markers/leaflet.awesome-markers.js';


import ElementPlus from 'element-plus' //全局引入
import 'element-plus/dist/index.css'

// 定义特性标志
window.__VUE_PROD_DEVTOOLS__ = false;
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;


L.AwesomeMarkers.Icon.prototype.options.prefix = 'bi';


const app = createApp(App)
app.use(router)
app.use(createPinia())
app.use(ElementPlus)
app.mount('#app')
